import apiClient from "pages/admin-app/service/apiClient";
import { GetCountriesRequest } from "../models/request/get-countries-request";
import { GetCountriesResponse } from "../models/response/get-countries-response";

export async function getCountries(
  request: GetCountriesRequest
): Promise<GetCountriesResponse> {
  const response = await apiClient.get<GetCountriesResponse>("/country", {
    params: {
      page: request.page,
      perPage: request.perPage,
    },
  });
  return response.data;
}

export async function getPaginatedByNameCountries(
  request: GetCountriesRequest
): Promise<GetCountriesResponse> {
  const response = await apiClient.get<GetCountriesResponse>(
    "/country/search-by-name",
    {
      params: {
        page: request.page,
        perPage: request.perPage,
        searchQuery: request.searchQuery,
      },
    }
  );

  return response.data;
}
